import { render, staticRenderFns } from "./GrupoEmpresarial.vue?vue&type=template&id=421afe77"
import script from "./GrupoEmpresarial.vue?vue&type=script&lang=js"
export * from "./GrupoEmpresarial.vue?vue&type=script&lang=js"
import style0 from "./GrupoEmpresarial.vue?vue&type=style&index=0&id=421afe77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports